import React, { useContext, useMemo, useState, useEffect } from 'react';

import { Button, Grid } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';

import axios from '../../sharedModules/utils/axios.utils';
import ListPage from '../../sharedModules/listPage/ListPage';
import { AuthenticationContext } from '../../homeModules/auth/contexts/AuthenticationContext';

const PhotoPagesXoiJobsListPage: React.FC = () => {
  const { user } = useContext(AuthenticationContext);
  const [ownerOptions, setOwnerOptions] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    axios
      .get('/developers/xoi_jobs', { params: { per_page: 1000 } })
      .then((response: any) => {
        const records = response.data.result || [];
        const unique = Array.from(new Set<string>(records.flatMap((r: any) => r.assignee_ids || []))).filter(Boolean);
        setOwnerOptions(unique.sort().map((o) => ({ label: o, value: o })));
      })
      .catch(() => {});
  }, []);

  const defaultFilterSetting = useMemo(() => {
    if (!user?.email) return undefined;
    return { assignee_email_eq: user.email };
  }, [user?.email]);

  const clearedFilterSetting = { assignee_email_eq: 'all' };

  const filterDefinitions = [
    {
      label: 'Job Owner',
      type: 'select',
      choices: ownerOptions,
      param: 'assignee_email_eq',
    },
  ];

  const photoPageXoiJobColumns = [
    {
      name: 'Customer Name',
      selector: 'customer_name',
      sortable: true,
      grow: 1,
    },
    {
      name: 'Job Location',
      selector: 'job_location',
      sortable: true,
      grow: 2,
    },
    {
      name: 'Completed',
      selector: 'completed_at_display',
      sortable: true,
      grow: 1,
    },
    {
      name: 'Job Owner',
      selector: (row) => row.assignee_ids.join(', '),
      sortable: false,
      grow: 2,
    },
    {
      name: 'Work Order Number',
      selector: 'work_order_number',
      sortable: true,
      grow: 1,
    },
    {
      name: 'XOI Created At',
      selector: 'xoi_created_at_display',
      sortable: true,
      grow: 1,
    },
    {
      name: 'Proposal PDF',
      selector: 'pdf_template_url',
      cell: (row) =>
        row.download_url && (
          <a href={row.download_url} target="_blank" rel="noopener noreferrer">
            <Button variant="contained" color="primary">
              <Visibility />
            </Button>
          </a>
        ),
    },
  ];

  return (
    <ListPage
      key={user?.email || 'loading'}
      clickableRows
      clearedFilterSetting={clearedFilterSetting}
      columns={photoPageXoiJobColumns}
      controller="developers/xoi_jobs"
      defaultFilters={defaultFilterSetting}
      defaultSort="created_at desc"
      filterDefinitions={filterDefinitions}
      includeFilterBar
      queryPlaceholder="Filter by customer name..."
      rowClickPath="photo_proposals"
      title="XOI Jobs"
    />
  );
};

export default PhotoPagesXoiJobsListPage;
